import { useCurrentuser } from '@uplift/contexts';
import { useProviderDetailsQuery } from '@uplift/queries';
import { UserRole } from '@uplift/types';

export const useIsCollaborativePhysician = () => {
  const me = useCurrentuser();
  const { data: providerDetails } = useProviderDetailsQuery(me.id, {
    enabled: me.role === UserRole.provider && !!me.id,
  });

  return me.role === UserRole.provider && providerDetails?.collaborativePhysician === true;
};
